import VideoEmailGate from './VideoEmailGate'

export default VideoEmailGate
// eslint-disable-next-line import/export
export * from './VideoEmailGate'
